import React, { useEffect, useState } from "react";
import {
  TableCell,
  TableRow,
  Paper,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { updateCIF } from "../Redux/Reducer/CIFReducer";
import { updateOceanInsurance } from "../Redux/Reducer/Insurance";
import { updateCIFValue } from "../Redux/Reducer/CIFUpdateReducer";

const fontStyle = {
  // fontFamily: "Inter",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "normal",
  cursor: " pointer",
  // letterSpacing: "-0.387px",
};

const bodyFontStyle = {
  fontWeight: 500,
  padding: "2px",
  borderRadius: "4px",
  alignItem: "center",
  border: "0.5px solid lightgrey",
};

const stickyStyle = {
  position: "sticky",
  left: 0,
  zIndex: 1,
  boxShadow: "4px 0px white",
  background: "white",
  alignItems: "center",
};
const FreightAndInsurance = ({
  selectedHeader,
  selectedPort,
  fobData,
  selectedData,
  countryNames,
  oceanFreightData,
  setFrightData,
  currency,
}) => {
  const rowHeight = 5;
  const [data, setData] = useState([]);
  const [tempEditData, setTempEditData] = useState({});
  const [insurance, setInsurance] = useState({});
  const [totals, setTotals] = useState([]);
  const [isRowEditing, setRowEditing] = useState(false);
  const dispatch = useDispatch();
  const [showRow, setShowRow] = useState(true);
  const CIFValues = useSelector((state) => state.CIFData.CIF);

  useEffect(() => {
    const output = countryNames.map((country) => {
      const matchingData = oceanFreightData?.find(
        (data) => data["country"].toLowerCase() === country.toLowerCase()
      );

      const cifData = CIFValues
        ? CIFValues.find((ele) =>
            Object.keys(ele).some(
              (key) => key.toLowerCase() === country.toLowerCase()
            )
          )
        : null;

      let cifValue = "";
      if (cifData) {
        const key = Object.keys(cifData).find(
          (k) => k.toLowerCase() === country.toLowerCase()
        );

        cifValue = cifData[key] ?? ""; // preserves 0 but avoids null/undefined
      }

      return {
        Country: country,
        // Ocean_Freight:
        //   country === selectedHeader
        //     ? "N/A"
        //     : cifValue !== ""
        //     ? 0
        //     : matchingData
        //     ? parseFloat(matchingData?.["ocean_freight_road_freight"])?.toFixed(
        //         1
        //       )
        //     : 0,
        Ocean_Freight:
          country === selectedHeader
            ? "N/A"
            : cifValue !== ""
            ? 0
            : matchingData &&
              !isNaN(parseFloat(matchingData?.["ocean_freight_road_freight"]))
            ? parseFloat(matchingData?.["ocean_freight_road_freight"]).toFixed(
                1
              )
            : 0,

        Insurance: cifValue !== "" ? 0 : 0,
        CIF: cifValue !== "" ? cifValue : 0,
        isEditingOcean: false,
        isEditingInsurance: false,
      };
    });

    if (output.length > 0) {
      const initialValues = {};
      output.forEach((row, index) => {
        initialValues[index] = row.Country === selectedHeader ? 0 : 1;
      });
      setInsurance(initialValues);
    }

    setData(output);
  }, [countryNames, selectedPort, selectedData, oceanFreightData, CIFValues]);

  useEffect(() => {
    const updateInsurance = (state) => {
      return state.map((item, index) => {
        const countryName =
          item.Country.charAt(0).toUpperCase() + item.Country.slice(1);
        const value = fobData[countryName];
        const insurancePercentage = insurance[item.id || index] || 0;
        return {
          ...item,
          Insurance: insurancePercentage
            ? ((Number(value) * insurancePercentage) / 100).toFixed(1)
            : 0,
          insurancePercentage: insurancePercentage,
        };
        // }
      });
    };
    setData((prevData) => updateInsurance(prevData));
  }, [fobData, insurance]);

  useEffect(() => {
    if (data.length < 1) return;
    dispatch(updateOceanInsurance(data));
  }, [data, countryNames, selectedPort]);

  const handleChange = (event, index, field) => {
    const inputValue = event.target.value || "0";
    if (field !== "total") {
      const updatedData = [...data];
      const updatedRow = { ...updatedData[index] };
      updatedRow[field] = event.target.value || "0";
      updatedData[index] = updatedRow;
      updatedData[index][field] = parseFloat(
        Number(event.target.value || "0").toFixed(1)
      );
      // setData(updatedData);
      //added new line
      const updatedTempData = { ...tempEditData };
      if (!updatedTempData[index]) {
        updatedTempData[index] = { ...data[index] };
      }
      updatedTempData[index][field] = event.target.value || "0";
      setTempEditData(updatedTempData);
      // updateTotals(updatedData);
    } else {
      const updatedData = [...totals];
      updatedData[index][field] = event.target.value;
      // setTotals(updatedData);
      let updatedObj = {};
      for (let i = 0; i < updatedData.length; ++i) {
        let country = updatedData[i]["Country"];
        let total = updatedData[i]["total"];
        updatedObj[country] = parseFloat(total);
      }
      dispatch(updateCIF(updatedObj));
    }
  };

  const toggleEditRow = (index, field) => {
    setRowEditing(!isRowEditing);
    setData((prevData) => {
      const updatedData = [...prevData];
      if (tempEditData[index]) {
        updatedData[index] = {
          ...updatedData[index],
          [field]: parseFloat(tempEditData[index][field]).toFixed(1),
        };
      }
      return updatedData;
    });
  };

  // function updateTotals(data) {

  //   // const countryTotals = data.reduce((acc, row) => {
  //   //   const countryName =
  //   //     row.Country.charAt(0).toUpperCase() + row.Country.slice(1);
  //   //   const cifData = CIFValues.find(
  //   //     (ele) => Object.keys(ele)[0].toLowerCase() === country.toLowerCase()
  //   //   );

  //   //   const cifValue = cifData ? cifData[Object.keys(cifData)[0]] : "";

  //   //   const value =
  //   //     cifData && cifValue !== "" && cifValue !== undefined
  //   //       ? Number(cifValue)
  //   //       : countryTotals[country];
  //   //   const countryValue = fobData[countryName] || 0;
  //   //   const total = [row.Ocean_Freight, row.Insurance, countryValue]
  //   //     .map(parseFloat)
  //   //     .filter((val) => !isNaN(val))
  //   //     .reduce((sum, val) => sum + val, 0);
  //   //   const roundedTotal = parseFloat(total.toFixed(1));
  //   //   acc[countryName] = roundedTotal;
  //   //   return acc;
  //   // }, {});
  //   const countryTotals = data.reduce((acc, row) => {
  //     const countryName =
  //       row?.Country?.charAt(0)?.toUpperCase() + row?.Country?.slice(1);

  //     // Find CIF value for this country
  //     const cifData = CIFValues.find(
  //       (ele) =>
  //         Object?.keys(ele)[0]?.toLowerCase() === countryName?.toLowerCase()
  //     );
  //     // const cifValue = cifData ? cifData[Object.keys(cifData)[0]] : "";
  //     let cifValue = "";
  //     if (cifData) {
  //       const key = Object.keys(cifData).find(
  //         (k) => k.toLowerCase() === countryName.toLowerCase()
  //       );

  //       cifValue = cifData[key] ?? ""; // preserves 0 but avoids null/undefined
  //     }

  //     // If CIF value exists and is not empty, use it. Otherwise compute from components.
  //     const total =
  //       cifData && cifValue !== "" && cifValue !== undefined
  //         ? parseFloat(cifValue)
  //         : [row.Ocean_Freight, row.Insurance, fobData[countryName] || 0]
  //             .map(parseFloat)
  //             .filter((val) => !isNaN(val))
  //             .reduce((sum, val) => sum + val, 0);

  //     // Round to 1 decimal
  //     acc[countryName] = parseFloat(total.toFixed(1));
  //     return acc;
  //   }, {});

  //   let result = Object.keys(countryTotals).map((country) => {
  //     const cifData = CIFValues.find(
  //       (ele) => Object?.keys(ele)[0]?.toLowerCase() === country?.toLowerCase()
  //     );

  //     const cifValue = cifData ? cifData[Object?.keys(cifData)[0]] : "";

  //     const value =
  //       cifData && cifValue !== "" && cifValue !== undefined
  //         ? Number(cifValue)
  //         : countryTotals[country];
  //     return {
  //       Country: country,
  //       total: value,
  //     };
  //   });
  //   dispatch(updateCIFValue(countryTotals));
  //   // updateCIFValue
  //   setTotals(result);
  // }

  function updateTotals(data) {
    const countryTotals = data.reduce((acc, row) => {
      const countryName =
        row?.Country?.charAt(0)?.toUpperCase() + row?.Country?.slice(1);

      const cifEntry = CIFValues.find((ele) =>
        Object.keys(ele).some(
          (k) => k.toLowerCase() === countryName?.toLowerCase()
        )
      );

      let cifValue = "";
      if (cifEntry) {
        const key = Object.keys(cifEntry).find(
          (k) => k.toLowerCase() === countryName?.toLowerCase()
        );
        cifValue = cifEntry[key] ?? "";
      }

      const total =
        cifEntry && cifValue !== "" && cifValue !== undefined
          ? parseFloat(cifValue)
          : [row.Ocean_Freight, row.Insurance, fobData[countryName] || 0]
              .map((val) => parseFloat(val))
              .filter((val) => !isNaN(val))
              .reduce((sum, val) => sum + val, 0);

      acc[countryName] = parseFloat(total.toFixed(1));
      return acc;
    }, {});

    const result = Object.keys(countryTotals).map((country) => {
      const cifEntry = CIFValues.find((ele) =>
        Object.keys(ele).some((k) => k.toLowerCase() === country.toLowerCase())
      );

      let cifValue = "";
      if (cifEntry) {
        const key = Object.keys(cifEntry).find(
          (k) => k.toLowerCase() === country.toLowerCase()
        );
        cifValue = cifEntry[key] ?? "";
      }

      const value =
        cifEntry && cifValue !== "" && cifValue !== undefined
          ? Number(cifValue)
          : countryTotals[country];

      return {
        Country: country,
        total: value,
      };
    });

    dispatch(updateCIFValue(countryTotals));
    setTotals(result);
  }

  React.useEffect(() => {
    if (data.length < 1) return;
    updateTotals(data);
  }, [fobData, data, insurance]);

  React.useEffect(() => {
    if (data && data.length > 0) {
      updateTotals(data);
    }
  }, []);

  const handleInsuranceChange = (event, index) => {
    const selectedValue = event.target.value;
    setInsurance((prevValues) => ({
      ...prevValues,
      [index]: selectedValue,
    }));
    // updateTotals(data);
  };

  function handleAddRow() {
    setShowRow(!showRow);
  }

  useEffect(() => {
    setFrightData(data);
  }, [data]);

  return (
    <>
      <TableRow className="row-gap"></TableRow>
      <>
        <TableRow
          className={`row-height first-row ${!showRow ? "" : "fade-row"}`}
        >
          <TableCell className="row-height sticky-cell cell-height ">
            <div className="align-main-cell ">
              {" "}
              <span className="label_style"> Ocean Freight /Road Freight</span>
              {isRowEditing ? (
                <div
                  style={{
                    color: "#1850FF",
                    ...fontStyle,
                    textDecoration: "underline",
                  }}
                  onClick={() =>
                    data.forEach((_, idx) =>
                      toggleEditRow(idx, "Ocean_Freight")
                    )
                  }
                  // size="small"
                  sx={{ height: rowHeight }}
                >
                  Save
                  {/* <CheckIcon /> */}
                </div>
              ) : (
                <div
                  onClick={() =>
                    data.forEach((_, idx) =>
                      toggleEditRow(idx, "Ocean_Freight")
                    )
                  }
                  style={{
                    color: "#1850FF",
                    ...fontStyle,
                    textDecoration: "underline",
                  }}
                >
                  Edit
                </div>
              )}
            </div>
          </TableCell>
          {data.map((row, index) => {
            // const result = countryNames.find((country) => {
            //   return typeof CIFValues[0]?.[country] === "string" || Number
            //     ? CIFValues[0][country] !== ""
            //     : CIFValues[0]?.[country] != null;
            // });
            const validCountries = countryNames.filter(
              (country) =>
                CIFValues[0]?.[country] !== "" &&
                CIFValues[0]?.[country] != null
            );
            const isCif = validCountries.includes(row.Country);
            return (
              <TableCell
                key={index}
                align="center"
                className="row-height cell-height"
              >
                {isRowEditing ? (
                  !isCif ? (
                    <TextField
                      value={
                        (tempEditData[index]?.Ocean_Freight !== undefined
                          ? tempEditData[index].Ocean_Freight
                          : row.Ocean_Freight) ?? 0
                      }
                      onChange={(event) =>
                        handleChange(event, index, "Ocean_Freight")
                      }
                      type="number"
                      sx={{ height: rowHeight, input: { textAlign: "center" } }}
                      InputProps={{
                        style: { height: rowHeight + 13, padding: "0px" },
                      }}
                    />
                  ) : (
                    ""
                  )
                ) : isCif ? (
                  ""
                ) : (
                  row.Ocean_Freight
                )}
              </TableCell>
            );
          })}
          <TableCell className="row-height cell-height sticky-button"></TableCell>
        </TableRow>
        <TableRow
          className={`row-height first-row ${!showRow ? "" : "fade-row"}`}
        >
          <TableCell className="row-height sticky-cell cell-height">
            <span className="label_style">Insurance %</span>
          </TableCell>
          {data.map((row, index) => {
            // const result = countryNames.find((country) =>
            //   typeof CIFValues[0]?.[country] === "string"
            //     ? CIFValues[0][country].trim() !== ""
            //     : CIFValues[0]?.[country] != null
            // );
            const validCountries = countryNames.filter(
              (country) =>
                CIFValues[0]?.[country] !== "" &&
                CIFValues[0]?.[country] != null
            );

            const isCif = validCountries.includes(row.Country);
            // const isCif = row.Country === result ? true : false;
            return (
              <TableCell
                key={index}
                align="center"
                className="row-height cell-height"
              >
                {isCif ? (
                  ""
                ) : (
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    // value={insurance}
                    value={insurance[index]}
                    label="insurance"
                    size="small"
                    sx={{
                      height: rowHeight + 18,
                      width: "100%",
                      margin: 0,
                      padding: 0,
                      fontSize: "0.675rem",
                      fontFamily: "Inter",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#00008B",
                      },
                      "& .MuiSelect-select": {
                        ...fontStyle,
                        fontWeight: 500,
                        paddingRight: "10px !important",
                        // color: "#00008B",
                        textAlign: "center",
                      },
                      "& .MuiOutlinedInput-root": {
                        paddingRight: 0,
                      },
                      // minWidth: "70%",
                      // maxWidth: "70%",
                    }}
                    onChange={(e) => handleInsuranceChange(e, index, row)}
                  >
                    <MenuItem value={0.5}>0.5%</MenuItem>
                    <MenuItem value={1.0}>1.0%</MenuItem>
                    <MenuItem value={1.5}>1.5%</MenuItem>
                    <MenuItem value={2.0}>2.0%</MenuItem>
                    <MenuItem value={0.0}>0.0%</MenuItem>
                  </Select>
                )}
              </TableCell>
            );
          })}
          <TableCell className="row-height cell-height sticky-button"></TableCell>
        </TableRow>
      </>

      <TableRow sx={{ borderRadius: "6px" }}>
        <TableCell className="row-height main-cell sticky-cell">
          <span style={{ display: "flex", justifyContent: "space-between" }}>
            <span className="label_style">CIF</span>
            {/* <span>($/MT)</span> */}
            <span>({currency.currency_symbol}/MT)</span>
          </span>
        </TableCell>

        {totals.map((row, index) => (
          <TableCell
            key={index}
            align="center"
            // className="row-height main-cell"
            className={
              `row-height main-cell`
              //    ${
              //   index === totals.length - 1 ? "last-cell" : ""
              // }`
            }
          >
            {row.isEditingCIF ? (
              <TextField
                value={row.total}
                onChange={(event) => handleChange(event, index, "total")}
                type="number"
                sx={{ height: rowHeight, input: { textAlign: "center" } }}
                InputProps={{
                  style: {
                    height: rowHeight + 14,
                    padding: "0px",
                    fontSize: "0.675rem",
                    borderRadius: "4px",
                  },
                }}
              />
            ) : (
              row.total?.toFixed(1)
            )}
          </TableCell>
        ))}
        {showRow ? (
          <TableCell
            className="row-height main-cell sticky-button"
            onClick={handleAddRow}
          >
            +
          </TableCell>
        ) : (
          <TableCell
            className="row-height main-cell sticky-button"
            onClick={handleAddRow}
          >
            -
          </TableCell>
        )}
      </TableRow>
    </>
  );
};

export default FreightAndInsurance;
